import { jsxs as c, jsx as s, Fragment as m } from "react/jsx-runtime";
import _, { useId as y } from "react";
import { c as v } from "./clsx-OuTLNxxd.js";
import { c as g } from "./createLucideIcon-WU3cnAkb.js";
import './Input.css';/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x = g("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]), f = "_Input_5s2gv_32", E = "_error_5s2gv_60", h = "_InputWrapper_5s2gv_67", b = "_ErrorIcon_5s2gv_72", N = "_ErrorMessage_5s2gv_83", r = {
  Input: f,
  error: E,
  InputWrapper: h,
  ErrorIcon: b,
  ErrorMessage: N
}, k = _.forwardRef(
  ({ "aria-describedby": i, "aria-invalid": t, className: d, errors: o, type: p, ...l }, I) => {
    const e = o !== void 0 && o.length > 0, a = `${y()}-error`, u = [i, e ? a : void 0].filter(Boolean).join(" ") || void 0;
    return /* @__PURE__ */ c("div", { className: r.InputWrapper, "data-cxy-name": "input", children: [
      /* @__PURE__ */ s(
        "input",
        {
          "aria-describedby": u,
          "aria-invalid": t ?? (e || void 0),
          className: v(r.Input, e ? r.error : "", d),
          ref: I,
          type: p,
          ...l
        }
      ),
      e && /* @__PURE__ */ c(m, { children: [
        /* @__PURE__ */ s(x, { "aria-hidden": !0, className: r.ErrorIcon }),
        /* @__PURE__ */ s("div", { id: a, children: o.map((n) => /* @__PURE__ */ s("p", { className: r.ErrorMessage, children: n }, n)) })
      ] })
    ] });
  }
);
k.displayName = "Input";
export {
  k as I
};
